import * as fromDatatype from '../datatype-library/index';

export interface app_mst_link_subject_to_role_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_subject_guid: fromDatatype.GuidDataFieldInterface;
  app_mst_role_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class app_mst_link_subject_to_role_RowClass
  implements app_mst_link_subject_to_role_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_subject_guid: fromDatatype.GuidDataFieldInterface;
  app_mst_role_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
